import AuthorizedRoute from 'Components/AuthorizedRoute';
import { SITE_PAGES } from 'Config';
import { user_roles } from 'Data/Enum';
import withRouter from 'Lib/hoc/withRouter';
import { Navigate, Route, Routes } from 'react-router';
import { isUserAuthorized } from 'Util';
import Reports from '../Reports';
import NewTransactionView from './NewTransactionView';
import ReconcileView from './ReconcileView';
import { TransactionAndChargesStateProvider } from './TransactionAndChargesContext';
import TransactionDetails from './TransactionDetails';
import TransactionListView from './TransactionListView';
import TransactionReview from './TransactionReview';

let TransDetailWithRouter = withRouter(TransactionDetails);

const Transactions = () => {
  return (
    <TransactionAndChargesStateProvider>
      <Routes>
        <Route path='/' element={<Navigate to='all' replace />} />
        <Route
          path='new'
          element={
            <AuthorizedRoute
              requiredAuth={SITE_PAGES.NEW_TRANSACTION.requiredAuth}>
              <NewTransactionView />
            </AuthorizedRoute>
          }
        />
        <Route
          path='all'
          element={
            <AuthorizedRoute
              requiredAuth={SITE_PAGES.ALL_TRANSACTIONS.requiredAuth}>
              <TransactionListView
                includeDeleteColumn={isUserAuthorized({
                  roles: [user_roles.ADMINISTRATOR, user_roles.TRANSACTOR],
                })}
              />
            </AuthorizedRoute>
          }
        />
        <Route
          path='all/:id'
          element={
            <AuthorizedRoute
              requiredAuth={SITE_PAGES.TRANSACTION_DETAIL.requiredAuth}>
              <TransDetailWithRouter />
            </AuthorizedRoute>
          }
        />
        <Route
          path='reconcile'
          element={
            <AuthorizedRoute requiredAuth={SITE_PAGES.RECONCILE.requiredAuth}>
              <ReconcileView />
            </AuthorizedRoute>
          }
        />
        <Route
          path='review'
          element={
            <AuthorizedRoute
              requiredAuth={SITE_PAGES.TRANS_REVIEW.requiredAuth}>
              <TransactionReview />
            </AuthorizedRoute>
          }
        />
        <Route
          path='reports'
          element={
            <AuthorizedRoute requiredAuth={SITE_PAGES.REPORTS.requiredAuth}>
              <Reports />
            </AuthorizedRoute>
          }
        />
      </Routes>
    </TransactionAndChargesStateProvider>
  );
};

let Page = withRouter(Transactions);
export default Page;
